import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
};
headerStyles.lastUpdateText = {
    css: css`
        padding-right: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-right: 0px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
headerStyles.sharingStatus = {
    statusText: {
        css: css`
            padding-right: 30px;
            div[class^="TooltipWrapper"] {
                top: 2px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-right: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};
